import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updateTeacherCollabApi } from "../../../../api/teacherCollab";
import { getAccessToken } from "../../../../api/auth";

import "./EditTeacherCollabForm.scss";

export default function EditTeacherCollabForm(props) {
  const { teacherCollab, setIsVisibleModal, setReloadTeacherCollabs } = props;
  const [teacherCollabData, setTeacherCollabData] = useState({});

  //trae los datos de tipo de proveedor
  useEffect(() => {
    setTeacherCollabData({
      teachercollab_code: teacherCollab.teachercollab_code,
      description: teacherCollab.description,
    });
  }, [teacherCollab]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!teacherCollabData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updateTeacherCollab = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let teacherCollabUpdate = teacherCollabData; //es let porque se va actualizando

      updateTeacherCollabApi(token, teacherCollabUpdate, teacherCollab._id).then(
        (result) => {
          if (
            result.message === "ERR_CONNECTION_REFUSED" ||
            result.message === "Failed to fetch" ||
            result.message === undefined
          ) {
            notification["error"]({
              message: "Servidor caido",
            });
            setIsVisibleModal(true);
          } else if (result.code !== 200) {
            notification["error"]({
              message: result.message,
            });
            setIsVisibleModal(true);
          } else {
            notification["success"]({
              message: result.message, //el mensaje que viene del server
            });
            //console.log("respuesta: " + result.message);
            setIsVisibleModal(false);
            setReloadTeacherCollabs(true);
          }
        }
      );
    }
  };

  return (
    <div className="edit-teachercollab-form">
      <EditForm
        teacherCollabData={teacherCollabData}
        setTeacherCollabData={setTeacherCollabData}
        updateTeacherCollab={updateTeacherCollab}
      />
    </div>
  );
}

function EditForm(props) {
  const {
    teacherCollabData,
    setTeacherCollabData,
    updateTeacherCollab
  } = props;

  return (
    <Form className="form-edit" onSubmit={updateTeacherCollab}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">
            Código
          </label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={teacherCollabData.teachercollab_code}
              onChange={(e) => setTeacherCollabData({ ...teacherCollabData, teachercollab_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
            //   placeholder="descripción"
              value={teacherCollabData.description}
              onChange={(e) =>
                setTeacherCollabData({ ...teacherCollabData, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updateTeacherCollab}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
